<template>
  <div v-if="playlistData.injects" class="injects">
    <h2 v-text="playlistData.injectsTitle ? playlistData.injectsTitle : 'Injects'"></h2>
    <div v-for="(item, index) in injects" :key="index" class="rounded inject-container">

      <header>
        <h2 class="inject-title" v-text="item.name"></h2>
        <button v-if="item.description" @click="openInfo(item)"><i class="material-icons">info</i></button>
        <button v-if="item.type != 'pdf' && item.type != 'video'" @click="openModal(item)"><i class="material-icons">launch</i></button>
      </header>

      <vue-plyr v-if="item.type == 'video'" :options="videoOptions" class="rounded">
        <video :poster="item.thumb" :src="item.src">
          <source :src="item.src" type="video/mp4" size="720">
        </video>
      </vue-plyr>

      <figure v-if="item.type == 'image' || item.type == 'map'" class="rounded">
        <img :src="item.image" />
      </figure>

      <div v-if="item.type == 'pdf'" class="file-download rounded">
        <a :href="item.src" :title="item.name" target="_blank" class="download-link">{{item.name}} <i class="material-icons">cloud_download</i> </a>
      </div>
    </div>
  </div>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "Injects",
  mixins: [scenarioMixin],
  data () {
    return {
      injects: [],
      videoOptions: {
        autoplay: false,
        playsinline: false
      }
    }
  },
  mounted () {
    this.getInjects()
  },
  computed: {
    
  },
  methods: {
    openModal (inject) {
      this.$store.dispatch('modalModule/setActive', inject )
    },
    openInfo (inject) {
      this.$store.dispatch('modalModule/setActive', {...inject, type: "description"} )
    },
    openMap (map) {
      this.$store.dispatch('modalModule/setActive', {...map, type: "image"} )
    },
    getInjectData (id) {
      return this.$store.getters["scenarioModule/getInject"](id);
    },
    getInjects () {
      this.injects = []
      this.playlistData.injects.forEach(inject => {
        this.injects.push(this.getInjectData(inject))
      });
    }
  }
}
</script>

<style scoped lang="scss">
h2 {
  color: var(--primary);
  width: 100%;
  margin-bottom: 1em;
  // padding: 0 20px;
}
.injects {
  padding: 25px;
  width: 100%;

  @media all and (max-width: 540px) {
    // padding: 10px;
  }
}
.inject-container {
  background-color: #E2E8FF;
  padding: 10px 3px 3px 3px;
  max-width: 720px;
  width: 100%;
  margin-bottom: 25px;
  max-height: 98vh;

  header {
    display: flex;
    align-items: center;
    margin: 0 0 1em 1em;

    button {
      color: var(--primary);

      &:hover {
        color: #e1651d;
      }
    }
  }

  h2 {
    color: var(--primary);
    font-size: 15px;
    font-weight: normal;
    margin-right: auto;
  }

  video {
    max-height: calc(98vh - 60px);
  }

  figure {
    margin: 0;
    
    img {
      max-width: 100%;
      max-height: calc(98vh - 60px);
    }
  }
  .file-download {
    width: 100%;
    background-color: #fff;
    padding: 3px 15px;

    a {
      color: var(--primary);
      text-decoration: none;
      display: flex;
      align-items: center;

      i {
        margin-left: 15px;
      }
      
      &:hover {
        color: #e1651d;
      }
    }
  }
}
</style>